export default {
  'delegationConfigurations.title': 'Manage Delegation Configurations',

  'delegationConfigurations.form.environment': 'Environment',
  'delegationConfigurations.form.process': 'Process',
  'delegationConfigurations.form.name': 'Delegated User',
};
